var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleOverflowFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM7 13.25C6.31 13.25 5.75 12.69 5.75 12C5.75 11.31 6.31 10.75 7 10.75C7.69 10.75 8.25 11.31 8.25 12C8.25 12.69 7.69 13.25 7 13.25ZM12 13.25C11.31 13.25 10.75 12.69 10.75 12C10.75 11.31 11.31 10.75 12 10.75C12.69 10.75 13.25 11.31 13.25 12C13.25 12.69 12.69 13.25 12 13.25ZM17 13.25C16.31 13.25 15.75 12.69 15.75 12C15.75 11.31 16.31 10.75 17 10.75C17.69 10.75 18.25 11.31 18.25 12C18.25 12.69 17.69 13.25 17 13.25Z",
    fill: "#0044C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleOverflowFigma);
export default __webpack_public_path__ + "static/media/circle-overflow-figma.772cdf57294b4b344e2ee4eb9126985b.svg";
export { ForwardRef as ReactComponent };